import {
  applyBrandIdentityToDocument,
  applyThemeAndColorsToDocument,
  createTenantBrandingCache,
  DEFAULT_HEADER_LOGO,
  TENANT_BRANDING_CACHE_KEY,
} from "@freyr/freyr-react-common-components";
import { COOKIE_SETUP, RIMS_LOCAL_STG_CONSTANTS } from "../constants";

const tenantBrandingCache = createTenantBrandingCache({
  cacheKey: RIMS_LOCAL_STG_CONSTANTS.TENANT_BRANDING_CACHE,
  cookieOptions: COOKIE_SETUP,
  mergeWithApi: false,
});

export {
  applyBrandIdentityToDocument,
  applyThemeAndColorsToDocument,
  DEFAULT_HEADER_LOGO,
  TENANT_BRANDING_CACHE_KEY,
};

export { DEFAULT_THEME_AND_COLORS } from "../types/branding";

export const {
  getCachedBranding,
  setCachedBranding,
  clearCachedBranding,
  getEffectiveBranding,
} = tenantBrandingCache;
